import { SwaggerResponse } from './Client';

export const LOCALTOKENKEY = 'currentToken';
export const PPNTOKEN='ppnToken';
export const REFRESHTOKEN='refreshToken';
export const POSTLOGOUTURL='postLogoutUrl';
/*
helper class to rename all _links to links in the strings
received from the back-end
*/

class InnerResponse {
  private _response: Response;

  public get status(): number {
    return this._response.status;
  }

  constructor(response: Response) {
    this._response = response;
  }

  public text(): Promise<string> {
    if (this.status !== 200) return this._response.text();
    else {
      return this._response.text().then((s: string) => {
        return Promise.resolve(s.replace(/_links/g, 'links'));
      });
    }
  }
}

export class BaseClient {
  private _token: string = '';

  public get token(): string {
    return this._token;
  }
  public set token(value: string) {
    this._token = value;
  }

  isAuthenicated(): boolean {
    return this.token !== '';
  }

  transformOptions(options: RequestInit): Promise<RequestInit> {
    if (this._token !== '') {
      if (!options.headers) options.headers = [];
      if (options.headers) {
        const authAttr = { authorization: 'Bearer ' + this._token };
        options.headers = { ...options.headers, ...authAttr };
      }
    }
    return Promise.resolve(options);
  }

  transformResult<DataType>(
    url: string,
    response: Response,
    promiseFct: (response: any) => Promise<SwaggerResponse<DataType>>
  ): Promise<SwaggerResponse<DataType>> {
    return promiseFct(new InnerResponse(response));
  }
}



// WEBPACK FOOTER //
// ./src/services/BaseClient.ts